import React from 'react';
import styled from 'styled-components';
import { FlexMiddle, FlexCenter } from '../Flex';
import { Tooltip, TooltipBody } from '../Tooltip';

const Track = styled.div`
  position: relative;
  background: ${({ theme, $isActive }) => ($isActive ? theme.colors.greenLight : theme.colors.grey2)};
  border-radius: 32px;
  width: 42px;
  height: 24px;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'no-drop' : 'pointer')};
  transition: background 200ms;
`;

const Knob = styled(FlexCenter)`
  position: absolute;
  background-color: ${({ theme, $isActive }) => ($isActive ? theme.colors.greenPositive : theme.colors.grey3)};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  top: 2px;
  left: ${({ $isActive }) => ($isActive ? 20 : 2)}px;
  transition: left 200ms;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme, $isActive }) => ($isActive ? theme.colors.greenPositive : theme.colors.grey3)};
    transition: color 200ms;

    circle {
      fill: ${({ theme, $isActive }) => ($isActive ? theme.colors.greenPositive : theme.colors.grey3)};
      transition: fill 200ms;
    }
  }
`;

const ToggleWithIcon = ({ value, onChange, Icon, isDisabled, className, tooltipText }) => {
  const handleClick = (e) => {
    if (!isDisabled) {
      onChange(!value, e);
    }
  };

  return (
    <FlexMiddle className={className}>
      <Tooltip disabled={!tooltipText} body={<TooltipBody body={tooltipText} />}>
        <Track $isActive={!!value} $isDisabled={isDisabled} onClick={handleClick}>
          <Knob $isActive={!!value}>{Icon && <Icon />}</Knob>
        </Track>
      </Tooltip>
    </FlexMiddle>
  );
};

export default ToggleWithIcon;
